import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { HttpLoaderFactory } from 'src/app/core';
import { FeatureSharedModule } from 'src/app/features/shared/feature-shared.module';
import { UtilsPipe } from 'src/app/shared/pipes/utils.pipe';

import { DirectivesModule } from '../../directives/directives.modules';
import { PipesModule } from '../../pipes/pipes.module';
import { CapacityInfoModule } from '../capacity-info/capacity-info.module';
import { SocialModule } from '../social/social.module';

import { CardEndUsersLineComponent } from './card-end-users-lines/card-end-users-line.component';
import { CardEndUsersPlanComponent } from './card-end-users-plan/card-end-users-plan.component';
import { CardPaginationComponent } from './card-pagination/card-pagination.component';
import { CardStandaloneComponent } from './card-standalone/card-standalone.component';
import { CardSelectionNumberActionsComponent } from './card-selection-number-actions/card-selection-number-actions.component';

@NgModule({
  declarations: [
    CardPaginationComponent,
    CardEndUsersPlanComponent,
    CardStandaloneComponent,
    CardEndUsersLineComponent,
    CardSelectionNumberActionsComponent,
  ],
  exports: [
    CardPaginationComponent,
    CardEndUsersPlanComponent,
    CardStandaloneComponent,
    CardEndUsersLineComponent,
    CardSelectionNumberActionsComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    InlineSVGModule,
    NzPaginationModule,
    NzCardModule,
    NzMenuModule,
    NzProgressModule,
    NzGridModule,
    NzIconModule,
    NzTypographyModule,
    NzDividerModule,
    PipesModule,
    NzToolTipModule,
    SocialModule,
    CapacityInfoModule,
    NzButtonModule,
    NzDropDownModule,
    NzDrawerModule,
    NzTagModule,
    FeatureSharedModule,
    TranslateModule.forChild({
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [UtilsPipe],
})
export class CardsModule {}
